import Scater from './ScaterChart/Scater';
import Radar from './Radar/Radar';
import BrandEquity from './BrandEquity/BrandEquity';
import ChartWrapper from './ChartsWrapper/ChartsWrapper';
import Bar from './Bar/Bar';
import StackedBar from './StackedBarChart/StackedBarChart';
import OpenQuestion from './OpenQuestion/OpenQuestion';
import Statement from './Statement/Statement';
import Activation from './Activation/Activation';

export default {
  Scater,
  Radar,
  BrandEquity,
  ChartWrapper,
  Bar,
  StackedBar,
  OpenQuestion,
  Statement,
  Activation,
};
